import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';
import { styled as StyledComp } from 'styled-components';

const CommonTooltip = StyledComp(Tooltip)`
  & .MuiTooltip-tooltip {
    background-color: #000;
    color: red;
    fontsize: 11;
  }
  &.MuiTooltip-popper {
    background-color: ${(props) => props.theme.colors.checkboxColor};
    color: #000;
  }
  &.MuiTooltip-popperInteractive {
    background-color: ${(props) => props.theme.colors.checkboxColor};
    color: #000;
  }
  &.tooltip-wrapper {
    margin-left: 7px;
  }
  & .tooltip-wrapper__text {
    // padding: 5px;
    // width: 20px;
    // height: 20px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    // border-radius: 100%;
    // color: #fff;
    // cursor: pointer;
    // font-size: 1rem;
    // background-color: ${(props) => props.theme.colors.checkboxColor};

    width: 18px;
    height: 18px;
    display: inline-block;
    text-align: center;
    line-height: 18px;
    border-radius: 100%;
    color: #fff;
    cursor: pointer;
    font-size: 0.8rem;
    background-color: ${(props) => props.theme.colors.checkboxColor};
    margin: 0 5px;

  }
`;

const DabaduTooltip = styled(({ className, ...props }: TooltipProps) => {
  return <CommonTooltip {...props} classes={{ popper: className }} />;
})(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default DabaduTooltip;
